// import { Icon } from '@/units/index';
import { useRef, useEffect } from 'react';
import { Props } from './types';
import { Root, NameContainer, Video } from './styles';
import { Box } from '@mui/material';

export default function ReelVideo({ track, name, enabled, avatarImage }: Props) {
  const ref = useRef<HTMLVideoElement>(null!);
  useEffect(() => {
    try {
      const el = ref.current;
      if (el && !el.src && track && typeof track.attach === 'function') {
        // attach only if no media is attached, don't reattach. Find better way to handle it
        el.muted = true;
        console.log(`Attaching ${name}`);
        track.attach(el);
      }
      return () => {
        console.log(`Detaching ${name}`);
        if (track && typeof track.detach === 'function') {
          track.detach(el);
        }
      };
    } catch (err) {
      console.error(err);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [track]);

  return (
    <Root>
      {/* {!track && (
        <span className="loader">
          <span>
            <Icon.Loading />
          </span>
          <p>Connecting...</p>
        </span>
      )} */}

      {/* video should always be present */}
      <Video ref={ref} style={{ visibility: enabled ? 'visible' : 'hidden' }} />
      {avatarImage && <Box component="img" m={0} width="100%" height="calc(100% - 38px)" sx={{ objectFit: 'contain' }} src={avatarImage} alt="avatar preview" />}

      {!enabled && (
        <NameContainer avatarImage={avatarImage}>
          <p>{name}</p>
        </NameContainer>
      )}
    </Root>
  );
}
